module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/5ba8936170c4420207f5693a76db2ec9.png";